<template>
<m-pageframe
    :title="title"
    :color="pageframe_color"
>
<v-container>

     <v-text-field
         label="Search"
         prepend-icon="mdi-magnify"
         v-model="full_text"
         v-on:input="update"
         autocomplete="off"
     >
         <v-menu
             bottom
             offset-y
             slot="append-outer"
         >
             <template v-slot:activator="{ on }">
                 <v-icon
                     v-on="on"
                 >
                     mdi-dots-vertical
                 </v-icon>
             </template>

             <v-list>
                <v-list-item
                     v-on:click="onClickCreate()"
                 >
                     <v-list-item-title>New...</v-list-item-title>
                 </v-list-item>

                <v-divider/>

                 <v-list-item
                     v-on:click="exportToExcel()"
                 >
                     <v-list-item-title>Export to Excel...</v-list-item-title>
                 </v-list-item>
             </v-list>
         </v-menu>
     </v-text-field>


    <v-layout row wrap>
         <v-flex
            flex-grow-0
            v-for="(item, index) in possible_include_states"
            :key="index"
         >
                <v-checkbox
                    :label="item.text"
                    v-model="include_states"
                    :value="item.value"
                    style="margin-right: 15px"
                    v-on:change="doUpdate"
                />
         </v-flex>
         <v-flex
             class="d-flex justify-end"
         >
             <v-switch
                 v-model="only_inlcude_user_account_payments"
                 :label="`Only Show My Payment Requests`"
                 v-on:change="doUpdate"
             ></v-switch>
         </v-flex>
     </v-layout>

    <m-payment-card
        v-for="(payment, index) in results"
        :key="index"
        :payment="payment"
        v-on:changed="doUpdate"
     />

    <m-payment-request-dialog
        ref="payment-request-dialog"
        v-on:ok="createPaymentRequest($event)"
        ok_label="Create"
        show_created_for
    />

</v-container>
</m-pageframe>
</template>

<script>
import PaymentCard from './payment-card.vue';
const _ = require('lodash');
export default {
    data() {
        return {
            only_inlcude_user_account_payments: this.$route.params.show_all !== 'true',
            organization_name: null,
            full_text: null,
            include_states: ['ready-to-process'],
            possible_include_states: [
                { 'text' : 'Open', value: 'open' },
                { 'text' : 'Void', value: 'void' },
                { 'text' : 'Ready to Process', value: 'ready-to-process' },
                { 'text' : 'Processed', value: 'processed' },
            ],

            results: [],
        }
    },
    mounted () {
        this.getOrganizationName();
        this.doUpdate();
    },

    created () {
        this.$event_bus.$on('upsert-payment', this.doUpdate);

    },

    beforeDestroy () {
        this.$event_bus.$off('upsert-payment',this.doUpdate);
    },

    methods: {

        update: _.debounce(function(){
            this.doUpdate();
        }, 751),

        doUpdate()
        {
            let search = {
                'organization_id' : this.$route.params.organization_id,
                'created_by_employee_ids' : [],
                'include_states' : this.include_states,
                'full_text' : this.full_text,
                'only_inlcude_user_account_payments' : this.only_inlcude_user_account_payments,
            };

            if (this.only_inlcude_user_account_payments)
            {
                search.created_by_employee_ids.push(this.$rc.$state.profile.employee_account.employee_id);
            }

            this.$rc.showSpinner();

            this.$rc.searchPayments(
                search,

                (data) => {
                    this.$rc.hideSpinner();
                    this.results = data.results;
                },

                () => {
                    this.$rc.hideSpinner();
                    this.results = [];
                }
            );
        },


        exportToExcel() {
            this.$rc.excelExport(
                    'EXPORT: /api/v1/payments/excel-export/:organization_id',
                    {
                        'organization_id': this.$route.params.organization_id,
                    }
                );
        },

        getOrganizationName() {
            this.$rc.getOrganizationLabel(
                this.$route.params.organization_id,

                (label) => {
                    this.organization_name = label;
                }
            );
        },

        onClickCreate()
        {
            this.$refs['payment-request-dialog'].showDialog();
        },

        createPaymentRequest(post_data)
        {
            this.$rc.showSpinner();

            this.$rc.rest(
                'PUT: /api/v1/payments/create-payment-request',

                post_data,

                (data) => {
                    this.$rc.hideSpinner();
                },

                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to create payment request');
                },
            );

        },
    },


    computed: {

        title() {
            if ( this.organization_name == null )
                return 'Payments';

            return this.organization_name + ' Payments';
        },

        pageframe_color() {
            if ( this.$route.params.organization_id !== this.$rc.$state.organization_id )
                return '#5D647C';
            else
                return '#F24653';
        }
    },

    watch: {
        '$route.params.show_all': function(newVal) {
            this.only_inlcude_user_account_payments = newVal !== 'true';
            this.doUpdate();
        }
    },
}
</script>

<style lang="scss" scoped>
</style>